// extracted by mini-css-extract-plugin
module.exports = {"content":"ClaimLandModal_content__2f4Hx"};